"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@qwkin/core");
var _image = require("@qwkin/image");
var _LoadingAnimation = _interopRequireDefault(require("../LoadingAnimation/LoadingAnimation"));
var _theme = require("../utils/theme");
var _Image = _interopRequireDefault(require("../Image/Image"));
var _imagePlaceholder = _interopRequireDefault(require("../../assets/images/imagePlaceholder.png"));
var _excluded = ["theme", "s3Key", "s3Bucket", "s3ZoomKey", "s3ZoomBucket", "placeholder", "shouldZoom", "children", "defaultContent", "cleanLoading"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LoadingComponent = function LoadingComponent(_ref) {
  var _ref$cleanLoading = _ref.cleanLoading,
    cleanLoading = _ref$cleanLoading === void 0 ? false : _ref$cleanLoading;
  return cleanLoading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement(_LoadingAnimation["default"], {
    color: "#000000"
  });
};
var S3PrivateImage = function S3PrivateImage(_ref2) {
  var _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? _theme.defaultTheme : _ref2$theme,
    s3Key = _ref2.s3Key,
    s3Bucket = _ref2.s3Bucket,
    s3ZoomKey = _ref2.s3ZoomKey,
    s3ZoomBucket = _ref2.s3ZoomBucket,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? _imagePlaceholder["default"] : _ref2$placeholder,
    shouldZoom = _ref2.shouldZoom,
    children = _ref2.children,
    defaultContent = _ref2.defaultContent,
    _ref2$cleanLoading = _ref2.cleanLoading,
    cleanLoading = _ref2$cleanLoading === void 0 ? false : _ref2$cleanLoading,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isLoading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isZoomLoading = _useState4[0],
    setZoomLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    imageSrc = _useState6[0],
    setImageSrc = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    imageZoomSrc = _useState8[0],
    setImageZoomSrc = _useState8[1];
  (0, _react.useEffect)(function () {
    if (s3Key !== null && s3Bucket !== null) {
      setLoading(true);
      _core.API.fromS3(s3Bucket, s3Key).then(function (file) {
        setImageSrc((0, _image.bufferArrToBase64)(file.Body));
        setLoading(false);
      })["catch"](function (e) {
        console.log(e);
        setImageSrc(defaultContent ? null : placeholder);
        setLoading(false);
      });
    }
  }, [s3Key]);
  (0, _react.useEffect)(function () {
    if (s3ZoomKey !== null && s3ZoomBucket !== null) {
      setZoomLoading(true);
      _core.API.fromS3(s3ZoomBucket, s3ZoomKey).then(function (file) {
        setImageZoomSrc((0, _image.bufferArrToBase64)(file.Body));
        setZoomLoading(false);
      })["catch"](function (e) {
        console.log(e);
        setImageSrc(defaultContent ? null : placeholder);
        setZoomLoading(false);
      });
    }
  }, [s3ZoomKey]);
  if (isLoading || isZoomLoading) {
    return /*#__PURE__*/_react["default"].createElement(LoadingComponent, {
      cleanLoading: cleanLoading
    });
  }
  if (!imageSrc && defaultContent) {
    return defaultContent;
  }
  return /*#__PURE__*/_react["default"].createElement(_Image["default"], (0, _extends2["default"])({
    shouldZoom: shouldZoom,
    theme: theme,
    src: (0, _image.isBase64String)(imageSrc) ? "data:image/gif;base64,".concat(imageSrc) : imageSrc,
    zoomSrc: (0, _image.isBase64String)(imageZoomSrc) ? "data:image/gif;base64,".concat(imageZoomSrc) : imageZoomSrc
  }, props));
};
var _default = exports["default"] = S3PrivateImage;